// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8201af4","147":"5961d603","295":"307327d8","574":"20667de7","807":"26c5b0ef","818":"618a851f","899":"fd536ffc","900":"30817e25","996":"e7927558"}[chunkId] + ".chunk.js";
};